export const setOpenMethodOptions = (options, KR) => {
  const { $store } = KR
  if (options.allowWithoutUserInteraction) {
    $store.dispatch('update', {
      confirmationModal: { forceDisplay: true }
    })
  }
}
